<script>
import { getErpLoginUrl } from './api';

export default {
  mounted() {
    getErpLoginUrl().then((res) => {
      if (res.code == 0) {
        window.sessionStorage.nowUrl = res.data;
        window.location.href = `${res.data}/jsp/login/out/exit.html?proIDen=5EEx+rTdFv/5kj/TK0A9DJ5xUSmGIq+E`;
      } else {
        // console.log(res)
      }
    });
  }
};
</script>
